const alphabeticSort = (a, b) => {
  const af = a && a.toLowerCase().replace(/\s/g, '');
  const bf = b && b.toLowerCase().replace(/\s/g, '');
  if (af < bf) {
    return -1;
  }
  if (af > bf) {
    return 1;
  }
  return 0;
};
const stringyObject = (obj) => JSON.stringify(obj).replace(/"([^"]+)":/g, '$1: ');
module.exports.stringyObject = stringyObject;
module.exports.alphabeticSort = alphabeticSort;
